import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { shouldShowLoginButton } from '../intents/SalesExtensionUtils';
import { Step } from 'signup-constants/Step';
import CheckYourEmailGoToLoginButton from './CheckYourEmailGoToLoginButton';
import GoToMailButton from './GoToMailButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CheckYourEmailMessage = ({
  email
}) => {
  const stepKey = Step.Verification;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `views.${stepKey}.sentEmailTo`,
        options: {
          email
        }
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `views.${stepKey}.clickTheLink`
      })
    }), shouldShowLoginButton() ? /*#__PURE__*/_jsx("p", {
      className: "m-y-9",
      children: /*#__PURE__*/_jsx(CheckYourEmailGoToLoginButton, {
        email: email
      })
    }) : /*#__PURE__*/_jsx("p", {
      className: "m-y-9",
      children: /*#__PURE__*/_jsx(GoToMailButton, {
        email: email
      })
    })]
  });
};